// src/pages/UserBin.js
import React, { useState, useEffect } from "react";
import { useAuth } from "../hooks/useAuth";

export default function UserBin() {
  const { user }  = useAuth();
  const [users,   setUsers]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);
  const [working, setWorking] = useState(null);

  async function load() {
    setLoading(true); setError(null);
    try {
      const res  = await fetch("/api/userbin");
      if (!res.ok) { const d=await res.json(); throw new Error(d.error||`HTTP ${res.status}`); }
      const data = await res.json();
      setUsers(data.users || []);
    } catch(e) { setError(e.message); }
    finally { setLoading(false); }
  }
  useEffect(() => { load(); }, []);

  async function handleRestore(u) {
    setWorking(u.email);
    try {
      const res = await fetch(`/api/userbin/${encodeURIComponent(u.email)}/restore`, { method:"POST" });
      if (res.ok) setUsers(prev => prev.filter(x => x.email !== u.email));
      else { const d = await res.json(); alert(d.error); }
    } catch(e) { alert(e.message); }
    finally { setWorking(null); }
  }

  async function handleDelete(u) {
    if (!window.confirm(`Permanently delete ${u.name||u.email}? This cannot be undone.`)) return;
    setWorking(u.email);
    try {
      const res = await fetch(`/api/userbin/${encodeURIComponent(u.email)}`, { method:"DELETE" });
      if (res.ok) setUsers(prev => prev.filter(x => x.email !== u.email));
      else { const d = await res.json(); alert(d.error); }
    } catch(e) { alert(e.message); }
    finally { setWorking(null); }
  }

  if (user?.role !== "admin") return <div className="card"><p>Admin access required.</p></div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">🗑 User Recycle Bin</div>
          <div className="page-subtitle">Deleted users — restore or permanently remove</div>
        </div>
      </div>

      <div className="card" style={{ padding:0, overflow:"hidden" }}>
        {loading ? (
          <div className="page-loading"><span className="spinner" style={{ width:24, height:24 }}/></div>
        ) : error ? (
          <div className="empty-state">
            <h3>Failed to load</h3>
            <p style={{ color:"var(--red)" }}>{error}</p>
            <button className="btn-secondary" style={{ marginTop:12 }} onClick={load}>Retry</button>
          </div>
        ) : users.length === 0 ? (
          <div className="empty-state">
            <div style={{ fontSize:40, marginBottom:12 }}>🗑</div>
            <h3>User bin is empty</h3>
            <p>Users deleted from Manage Users will appear here.</p>
          </div>
        ) : (
          <table className="contacts-table">
            <thead>
              <tr><th>Name</th><th>Email</th><th>Type</th><th>Archived</th><th>Deleted</th><th></th></tr>
            </thead>
            <tbody>
              {users.map(u => (
                <tr key={u.email} className="contact-row">
                  <td className="contact-cell"><div className="contact-name">{u.name||"—"}</div></td>
                  <td className="contact-cell" style={{ fontSize:13, color:"var(--gray-500)" }}>{u.email}</td>
                  <td className="contact-cell"><span className={`badge ${u.isExternal?"badge-due":"badge-ok"}`} style={{ fontSize:11 }}>{u.isExternal?"External":"M365"}</span></td>
                  <td className="contact-cell" style={{ fontSize:13, color:"var(--gray-500)" }}>{u.archivedAt ? new Date(u.archivedAt).toLocaleDateString("en-GB") : "—"}</td>
                  <td className="contact-cell" style={{ fontSize:13, color:"var(--gray-500)" }}>{u.deletedAt  ? new Date(u.deletedAt).toLocaleDateString("en-GB")  : "—"}</td>
                  <td className="contact-cell">
                    <div style={{ display:"flex", gap:6, justifyContent:"flex-end" }}>
                      <button className="btn-secondary" style={{ fontSize:12, padding:"4px 12px" }}
                        onClick={() => handleRestore(u)} disabled={working===u.email}>
                        {working===u.email ? "…" : "↩ Restore"}
                      </button>
                      <button className="btn-ghost" style={{ fontSize:12, padding:"4px 10px", color:"var(--red)" }}
                        onClick={() => handleDelete(u)} disabled={working===u.email}>
                        Delete Forever
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {users.length > 0 && (
        <p style={{ fontSize:12, color:"var(--gray-400)", marginTop:12, textAlign:"center" }}>
          Restoring a user sets them to Archived — reactivate them from Manage Users.
        </p>
      )}
    </div>
  );
}
